import * as React from "react";
import styles from "./styles.module.css";
import InsuranceCard from "../InsuranceCard";
import { Heading } from "@/components/Shared";

const data = [
	{
		title: "Car Insurance",
		src: "/insurance/car-insurance",
		icon: {
			color: "blue",
			src: "/icons/car.svg",
			alt: "Car Insurance",
			width: 32,
			height: 32,
		},
	},
	{
		title: "Home Insurance",
		src: "/insurance/home-insurance",
		icon: {
			color: "teal",
			src: "/icons/house.svg",
			alt: "Home Insurance",
			width: 32,
			height: 32,
		},
	},
	{
		title: "Van Insurance",
		src: "/insurance/van-insurance",
		icon: {
			color: "purple",
			src: "/icons/van.svg",
			alt: "Van Insurance",
			width: 32,
			height: 32,
		},
	},
	{
		title: "Bicycle Insurance",
		src: "/insurance/bicycle-insurance",
		icon: {
			color: "red",
			src: "/icons/bike.svg",
			alt: "Bicycle Insurance",
			width: 32,
			height: 32,
		},
	},
	{
		title: "Pet Insurance",
		src: "/insurance/pet-insurance",
		icon: {
			color: "purple",
			src: "/icons/pet.svg",
			alt: "Pet Insurance",
			width: 32,
			height: 32,
		},
	},
	{
		title: "Travel Insurance",
		src: "/insurance/travel-insurance",
		icon: {
			color: "teal",
			src: "/icons/travel.svg",
			alt: "Travel Insurance",
			width: 32,
			height: 32,
		},
	},
];

const InsuranceCardList: React.FC<{ title: string }> = ({ title }) => {
	const cardList = data.map((usp, index) => (
		<div
			className="col-xl-4 col-lg-4 col-md-4 col-sm-5  mb-4 mb-4 "
			key={index}
		>
			<InsuranceCard icon={usp.icon} card={usp} />
		</div>
	));

	return (
		<section className="bg-blue p-1" id="insurance-cards">
			<div className={`${styles.panel__section} container`}>
				<div className={"text-center mb-5"}>
					<Heading title={title} isBold={false} variant={2} />
				</div>
				<div className="row">
					<div className="col-12 col-xl">
						<div className="row justify-content-center">{cardList}</div>
					</div>
				</div>
			</div>
		</section>
	);
};

export default InsuranceCardList;
